/**
 * Parse a date-only string at LOCAL midnight.
 *
 * `new Date('YYYY-MM-DD')` parses as UTC midnight, so in any non-UTC timezone a
 * date-only value lands on the wrong calendar day (the previous day west of UTC,
 * the next day east of it). Comparing such a value against a local "today" then
 * misfires on the today/future boundary. This parses the same string at LOCAL
 * midnight so the calendar day the user typed is the day the code sees, in every
 * timezone. Same root cause and approach as the react-admin BQBD-5213 fix.
 *
 * @param {string|Date} value - 'YYYY-MM-DD' string, or a Date (passed through)
 * @returns {Date|null} local-midnight Date, or null if not a valid date-only value
 */
export function parseLocalDate(value) {
  if (value instanceof Date) return value;
  if (typeof value !== 'string') return null;

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);

  // Reject calendar overflow (e.g. 2020-02-30 -> Mar 1, 2026-13-01 -> next year):
  // a valid date round-trips to the same components it was built from.
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}
